import { ReceiptModule } from './receipt.module';
import { OrderPaymentReceiptComponent } from './orderPaymentReceipt';
import { OrderReviewReceiptComponent } from './orderReviewReceipt';

export { ReceiptModule, OrderPaymentReceiptComponent, OrderReviewReceiptComponent };
